export const NETWORK_EXCEPTION = 'NETWORK_EXCEPTION';
